import { useQuery } from "@tanstack/react-query";
import api from "@/lib/api";
import { Twitter, Send, MessageCircle, Globe, Link2 } from "lucide-react";

export const PLATFORMS = [
  { value: "x", label: "X / Twitter" },
  { value: "telegram", label: "Telegram" },
  { value: "discord", label: "Discord" },
  { value: "website", label: "Website" },
  { value: "other", label: "Other / Custom" },
];

export const platformIcon = (p) =>
  ({ x: Twitter, telegram: Send, discord: MessageCircle, website: Globe, other: Link2 }[p] || Link2);

// Public single source of truth — only enabled, non-empty links (server-filtered).
export function useCommunityLinks() {
  return useQuery({
    queryKey: ["community-links"],
    queryFn: async () => (await api.get("/community-links")).data,
    staleTime: 30_000,
  });
}
